import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminSyncPage = () => {
  const { t } = useTranslation();
  const [syncing, setSyncing] = useState(false);
  const [result, setResult] = useState(null);

  const syncIngredientTranslations = async () => {
    if (!window.confirm('Sync all ingredient translations? This will update all ingredients in the database.')) {
      return;
    }

    setSyncing(true);
    setResult(null);

    try {
      const response = await axios.post(`${API}/api/admin/sync-ingredient-translations`);
      setResult(response.data);
      alert(response.data.message || 'Sync completed successfully!');
    } catch (error) {
      console.error('Sync error:', error);
      alert(error.response?.data?.detail || 'Sync failed');
      setResult({ success: false, error: error.message });
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Admin: Sync Ingredient Translations</h1>

      <div className="bg-white rounded-lg shadow p-6 max-w-2xl">
        <div className="mb-4">
          <h2 className="text-xl font-semibold mb-2">Ingredient Translation Sync</h2>
          <p className="text-gray-600 mb-4">
            This will add translation fields (name_fr, name_de, name_en) to all ingredients in the database.
            Existing translations will be updated with basic translations based on common words.
          </p>
        </div>

        <button
          onClick={syncIngredientTranslations}
          disabled={syncing}
          className={`px-6 py-3 rounded-lg font-semibold text-white ${
            syncing
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {syncing ? 'Syncing...' : 'Sync Ingredient Translations'}
        </button>

        {result && (
          <div className={`mt-6 p-4 rounded-lg ${
            result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
          }`}>
            <h3 className="font-semibold mb-2">
              {result.success ? '✅ Success' : '❌ Error'}
            </h3>
            <pre className="text-sm whitespace-pre-wrap">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}

        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <h3 className="font-semibold mb-2">⚠️ Note:</h3>
          <ul className="text-sm text-gray-700 space-y-1">
            <li>• This operation updates ALL ingredients</li>
            <li>• Basic translations are applied automatically</li>
            <li>• Brand names remain unchanged</li>
            <li>• You can improve translations manually later in admin panel</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminSyncPage;
